<template>
  <button
    class="transition-all px-4 py-2 border font-semibold text-sm hover:border-gray-brand-600 mr-2 mb-2 text-left"
    :class="[
      selected ? 'text-gray-brand-100 bg-gray-brand-600' : 'text-gray-brand-600',
      outOfStock ? 'opacity-50 cursor-not-allowed' : ''
    ]"
    :disabled="outOfStock"
    @click="clicked"
  >
    {{ variantOption.name }}
    <span v-if="hasPrice && showPrice && showPlusSign">(+{{ variantOption.price_formatted.format }})</span>
    <span v-else-if="hasPrice && showPrice">({{ variantOption.price_formatted.format }})</span>
    <div v-if="variantOption.description" class="font-normal" data-testid="variant-option-description">
      {{ variantOption.description }}
    </div>
  </button>
</template>

<script>
export default {
  name: 'V2ProductVariantOption',

  props: {
    variantOption: {
      type: Object,
      required: true
    },
    variant: {
      type: Object,
      required: true
    },
    submittableCartItem: {
      type: Object,
      default: null
    },
    showPrice: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    pricingTiers: {
      type: Array,
      default: () => []
    }
  },

  emits: ['selected', 'unselected'],

  computed: {
    selected() {
      if (!this.submittableCartItem?.cart_item_variant_options_attributes) return false
      return this.submittableCartItem.cart_item_variant_options_attributes
        .map((x) => x.variant_option_id)
        .includes(this.variantOption.id)
    },
    outOfStock() {
      return !this.selected && this.variantOption.inventory_remaining === 0
    },
    hasPrice() {
      return this.variantOption.price_cents > 0
    },
    showPlusSign() {
      return this.product.price_cents > 0
    }
  },

  methods: {
    clicked() {
      if (this.outOfStock) return
      if (this.selected) {
        this.$emit('unselected', this.variantOption)
      } else {
        this.$emit('selected', this.variantOption)
      }
    }
  }
}
</script>
